<template>
  <CustomDeleteDialog
    dialogTitle="حذف جلسه رزرو شده"
    dialogId="delete-reserved-schedule-confirmation-second"
    okTitle="بله"
    no-close-on-backdrop
    :isOkDisabled="isLoading"
    @ok="deleteSchedule"
  >
    <BCol cols="12">
      <p class="text-danger font-weight-bolder">آیا اطمینان دارید؟</p>
    </BCol>
  </CustomDeleteDialog>
</template>
<script>
export default {
  emits: ["deleteSchedule"],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    deleteSchedule() {
      this.$emit("deleteSchedule");
    },
  },
  components: {
    CustomDeleteDialog,
    BCol,
  },
};
import { BCol } from "bootstrap-vue";
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
</script>
